import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { LocalizedRichDescription } from '../../models/serializable/localized-rich-description.js';
import { LocalizedString } from '../../models/serializable/localized-string.js';
import { PhotoReference } from '../../models/serializable/file-reference/photo-reference.js';
import { MapUtils } from '../../utility/map-utils.js';
import { RenderableComponent } from '../core/component.js';

/**
 * @deprecated Use `LocalizedRichTextComponent' instead.
 */
export class LegacyLocalizedRichTextComponent extends RenderableComponent {
  static readonly TYPE_ID: string = '37303397124b42f5b9f0dc2ee4fc4501';
  static readonly DEFAULT_RENDER_ORDER: number = 12;

  constructor(
    public readonly titles: LocalizedString,
    public readonly richDescriptions: LocalizedRichDescription,
    public readonly photo: PhotoReference | null,
    public readonly alwaysExpanded: boolean,
    public readonly renderOrder: number,
    public readonly isRenderingEnabled: boolean,
  ) {
    super();
  }

  get $typeId(): string {
    return LegacyLocalizedRichTextComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return true;
  }

  static fromMap(context: SerializationContext, map: SerializedData): LegacyLocalizedRichTextComponent {
    return new LegacyLocalizedRichTextComponent(
        context.fromData<LocalizedString>(MapUtils.get<SerializedData>(map, 'titles')),
        context.fromData<LocalizedRichDescription>(MapUtils.get<SerializedData>(map, 'richDescriptions')),
        context.fromDataOrNull<PhotoReference>(MapUtils.getOrNull<SerializedData>(map, 'photo')),
        MapUtils.get<boolean>(map, 'alwaysExpanded'),
        MapUtils.get<number>(map, 'renderOrder'),
        MapUtils.get<boolean>(map, 'isRenderingEnabled'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'titles': context.toData(this.titles),
      'richDescriptions': context.toData(this.richDescriptions),
      'photo': context.toDataOrNull(this.photo),
      'alwaysExpanded': this.alwaysExpanded,
      'renderOrder': this.renderOrder,
      'isRenderingEnabled': this.isRenderingEnabled,
    };
  }

  clone(): this {
    return new LegacyLocalizedRichTextComponent(
        this.titles.clone(),
        this.richDescriptions.clone(),
        this.photo?.clone() ?? null,
        this.alwaysExpanded,
        this.renderOrder,
        this.isRenderingEnabled
    ) as this;
  }

  isSame(other: LegacyLocalizedRichTextComponent): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.titles, this.titles) &&
      isSameData(other.richDescriptions, this.richDescriptions) &&
      isSameData(other.photo, this.photo) &&
      other.alwaysExpanded === this.alwaysExpanded &&
      other.renderOrder === this.renderOrder &&
      other.isRenderingEnabled === this.isRenderingEnabled;
  }
}

export class LegacyLocalizedRichTextComponentBuilder extends DataModelBuilder<LegacyLocalizedRichTextComponent> {
  build(context: SerializationContext, map: SerializedData): LegacyLocalizedRichTextComponent {
    return LegacyLocalizedRichTextComponent.fromMap(context, map);
  }
}
